let myTheme = {
	primary: '#2C2E4D',  //默认的主题色
    secondary: '#24DBD1;',
	success: '#4caf50',
	warning: '#fdd835',
	info: '#2196f3',
	error: '#FF5330',
	track: '#bdbdbd',
	text: {
		primary: '#2C2E4D',
		secondary: '#898CA3',
		alternate: '#fff',
		disabled: 'rgba(0, 0, 0, 0.38)',
		hint: 'rgba(0, 0, 0, 0.38)' // 提示文字颜色
	},
	divider: 'rgba(0, 0, 0, 0.12)',
	background: {
		paper: '#fff',
		chip: '#e0e0e0',
		default: '#F9F9FC'
	}
}

export default myTheme
